import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location, getLocaleDateTimeFormat } from '@angular/common';
import { ReportService } from '../Services/report.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-day-report',
  templateUrl: './day-report.component.html',
  styleUrls: ['./day-report.component.css']
})
export class DayReportComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  user_code: any;
  date: any;
  Reports: any;
  TodayReports = [];

  public DailyReport = { today_comment: '' };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    public auth: AuthService,
    private DBserivice: ReportService,
  ) { }

  ngOnInit() {
    this.getReport();
  }

  //DBから日報取得（なければ新規作成）
  getReport() {
    this.user_code = +this.route.snapshot.paramMap.get('user_code');
    this.date = this.route.snapshot.paramMap.get('date');
    if (this.user_code == 0) {
      this.user_code = this.logininfo.user_code;
      //this.user_code = this.auth.getUserCode();
    }
    if (this.date == null) {
      let dt = new Date();
      this.date = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
    }

    this.DBserivice.getDailyReport(this.user_code, this.date).subscribe(
      (daily: any) => {
        this.DailyReport = daily;
      }
    );
  }

  //編集画面へ
  edit() {
    this.router.navigate(['/day-edit', this.user_code, this.date], { relativeTo: this.route });
    //this.router.navigate(['/day-edit'], { relativeTo: this.route });
  }

  //保存
  save() {
    this.router.navigate(['/day-list'], { relativeTo: this.route });
  }
}
